/**
 * Created by renatolovizotto on 01/08/17.
 */
import {observable, action} from 'mobx';
import questions from '../assets/data/questions.json';

class GameStore {

    @observable teamColors = [
        {
            color: "red",
            name: "Red"
        },
        {
            color: "green",
            name: "Green"
        },
        {
            color: "yellow",
            name: "Yellow"
        }, {
            color: "cyan",
            name: "Blue"
        }];

    @observable numberRounds = 9;
    @observable teamsComposition = [
        {
            teams: 2,
            participants: 6,
        },
        {
            teams: 3,
            participants: 4,
        },
        {
            teams: 4,
            participants: 3,
        }
    ];
    @observable numberPlayers = 2;
    @observable answers = [
        {
            label: "Incorrect answer",
            points: 0,
        },
        {
            label: "Asked the teacher for help",
            points: 2,
        },
        {
            label: "Asked the group for help",
            points: 4,
        },
        {
            label: "Answered it individually",
            points: 6,
        }
    ];
    @observable levels = [];
    @observable questions = []; // All questions
    @observable players = []; // Players Selected with updated scores
    @observable winner; // Game's Winner
    @observable round = 1;
    @observable isLoading = false;
    @observable selectedAnswer = -1;
    @observable actualPlayer = null;
    @observable alreadyPlayed = [];
    @observable winners = [];

    @action
    resetGame() {
        this.levels = [];
        this.questions = [];
        this.round = 1;
        this.selectedAnswer = -1;
        this.actualPlayer = null;
        this.alreadyPlayed = [];
        this.winners = [];
        this.players = [];
    }

    @action
    loadQuestions() {
        this.questions = questions;
        this.levels = Object.keys(questions).map(
            (level, index) => ({id: index, name: level})
        );
    }

    @action
    setPlayers(numberPlayers) {


        let p = [];
        for (let i = 0; i < numberPlayers; i++) {
            const player = {
                name: this.teamColors[i].name + " team",
                team: this.teamColors[i],
                levels: [],
                score: 0,
            };

            p.push(player);
        }

        // Modify the state only one time
        this.players = p;
        this.numberPlayers = p.length;
    }

    @action
    changeRound() {
        this.alreadyPlayed = [];
    }

    @action
    setLevelToPlayerAt(player, level, index) {
        // Prevent insert level to index out of bounds
        if (player.levels.length < index) {
            player.levels.length = index;
        }

        player.levels[index] = level;
    }

    @action
    getRandomPlayer() {
        let randomPlayer = Math.floor(Math.random() * this.players.length);

        // Prevent same player play repeated on the round
        while (this.alreadyPlayed.indexOf(randomPlayer) !== -1) {
            randomPlayer = Math.floor(Math.random() * this.players.length);
        }

        this.alreadyPlayed = [...this.alreadyPlayed, randomPlayer];

        return this.players[randomPlayer];
    }

    @action
    getRandomQuestionByLevel(levels) {
        // Get random level
        let level = levels[Math.floor(Math.random() * levels.length)];

        // TODO: improve this loop removing "N/A" and undefined from levels
        while (level === "N/A" || level === undefined) {
            console.log('repetiu para sempre');
            level = levels[Math.floor(Math.random() * levels.length)];
        }

        // Get random question
        const questionsByLevel = this.questions[level];
        const questionIndex = Math.floor(Math.random() * questionsByLevel.length);
        const question = questionsByLevel[questionIndex];

        // Remove question to NOT REPEAT
        this.questions[level] = [...this.questions[level].filter(q => q !== question)];

        return {statement: question, level};
    }
}

export default new GameStore();


// WEBPACK FOOTER //
// ./src/stores/GameStore.js